const totals = state => state.totals;
const chargeTotals = state => state.chargeTotals;
const isNegativeBalance = state => state.chargeTotals?.balance < 0;
const isTPPWidgetVisible = state => state.isTPPWidgetVisible;
const oneYearPeriods = state => state.oneYearPeriods;

export default {
    totals,
    chargeTotals,
    isNegativeBalance,
    isTPPWidgetVisible,
    oneYearPeriods,
};
